module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1291.a2ee3a8a.png";